import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import HeaderSection from "../components/head-section-two";
import ProductSingle from "../components/product";
import productList from '../components/product.json'
const OrderTracking = () =>{
    document.body.style.backgroundColor = "white"
    return (
        <div>
            <Header />
               <HeaderSection 
               title="Order Tracking" 
               smallTitle="Home / Shop /" 
               usmallTitle="Shop Without Sidebar"
               />
               <section id="section_shop">
                   <div id="order_id_div">
                      <p id="order_id_text">To track your order please enter your Order ID in the box below and press the "Track" button. This was given to you on your receipt and in the confirmation email you should have received.</p>
                     <hr id="order_id_hr" />
                     <label id="order_id_labal">Order ID</label>
                     <input type="text"  id="order_id_div_input"/>
                     <label id="order_id_labal">Billing email</label>
                     <input type="text"  id="order_id_div_input"/>
                     <button id="order_id_button">Tracking order</button>
                   </div>
                   <hr id="order_id_hr" style={{marginTop:"40px"}} />
                    <p id="similar_products">Your Recently Viewed Products</p>
                    <div id="grid_4_cart">
                        {
                            productList.map((v,k)=>{
                                return <ProductSingle key={k} data={v}/>
                            })
                        }
                    </div>
               </section>
            <Footer />
        </div>
    )
}
export default OrderTracking;
